let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("dWYyz"), load("bW1lK"), load("lCI1e")]).then(() => parcelRequire('lN1kQ'));